import type { Comment } from './comment'
import type { Picture } from './common'
import type { User } from './user'

export enum StoryStatus {
	NONE = 'NONE',
	PICTURE = 'PICTURE',
	VIDEO = 'VIDEO',
	READ = 'READ',
}

export enum StoryMediaType {
	PICTURE = 'PICTURE',
	VIDEO = 'VIDEO',
}

export enum StoryVisibility {
	PUBLIC = 'PUBLIC',
	PRIVATE = 'PRIVATE',
	EXPIRED = 'EXPIRED',
}

export interface StoryVideo {
	duration: number
	width: number
	height: number
	image?: Picture | null
}

export interface Story {
	type: 'STORY'
	id: string
	user: User
	createdAt: string
	status: StoryVisibility | null
	storyType: StoryMediaType
	picture?: Picture | null
	video?: StoryVideo | null
	thumbnailVideo?: StoryVideo | null
	emoji?: string | null
	liked: boolean
	likeCount: number
	viewerCount: number
	commentCount: number
	attachedComments: Comment[]
	likedUsers: User[]
	isFeatured: boolean
	topEndowers: User[]
	endowCount: number
	endowerCount: number
	endowed: boolean
	silentMentionCount: number
	readTrackInfo?: Record<string, unknown>
}

export enum StoryFeedType {
	USER_STORY = 'USER_STORY',
	STORY_RESOURCE = 'STORY_RESOURCE',
}

export interface StoryFeedResource {
	id: string
	image: string
	url: string
	title: string
	persistent: boolean | null
}

export interface UserStoryFeed {
	type: StoryFeedType.USER_STORY
	user: User
	data?: null
}

export interface StoryResourceFeed {
	type: StoryFeedType.STORY_RESOURCE
	user?: null
	data: StoryFeedResource
}

export type StoryFeed = UserStoryFeed | StoryResourceFeed
